import React, { useEffect } from "react";
import { withRouter } from "react-router";
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import _ from "lodash";

import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as socketAction from "redux/sockets/action";
import * as gameParamAction from "redux/gameParams/actions";
import FindActivity from "./components/FindActivity";
import ActivityHeader from "./components/ActivityHeader";
import ViewActivity from "./components/ViewActivity";
import useWindowSize from "components/shared/WindowResize";
import Footer from "../landingLibrary/Footer";
import SideBarTabs from "../landingLibrary/sideBarTabs";

const Activities = ({ history, gameReducer, set_view_activity, ...props }) => {
  const { width } = useWindowSize();
  const view_activity = _.get(gameReducer, "view_activity", {});
  const current_user = _.get(gameReducer, "currentUser", {});
  const team = _.get(current_user, "team");
  const teamCode = _.get(team, "id");
  const sessionObj = _.get(gameReducer, "sessionObj");
  const sessionId = _.get(sessionObj, "session_id");
  const link = _.get(sessionObj, "branch_url");
  const browse_activities = _.get(
    gameReducer,
    "gamesData.game_library_v2.browse",
    {}
  );
  const team_session_params = _.get(
    gameReducer,
    "gamesData.game_library_v2.team_session"
  );

  useEffect(() => {
    props.setGameName("");
    props.endGame(true);
    props.emptyGameData({});
    return () => {
      set_view_activity({});
    };
  }, []);

  const handleViewActivity = (activity, type) =>
    set_view_activity({ activity: activity, type: type });

  const handleStartActivity = async (activity) => {
    props.setIsLoading(true);
    const game_code = activity?.game_code;
    let gameCodee = game_code;
    if (activity?.editions) {
      props.setEditions(activity?.editions);
      if (
        activity?.background &&
        activity?.background_mobile &&
        activity?.top_logo &&
        activity?.top_logo_mobile
      ) {
        props.setLTparameters({
          background: activity?.background,
          background_mobile: activity?.background_mobile,
          top_logo: activity?.top_logo,
          top_logo_mobile: activity?.top_logo_mobile
        });
      }
    }
    if (game_code === "WELL") {
      props.setWellnessParamsOnject(activity);
    }
    var cognitoUser = await Auth.userPool.getCurrentUser();

    if (cognitoUser !== null) {
      if (width < 768) {
        props.setGameName(gameCodee);
        history.push("/launch_controller");
      } else {
        if (gameCodee === "GAHW") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("GAH");
        } else if (gameCodee === "GAHF") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("GAH");
        } else if (gameCodee === "CHPTW") {
          localStorage.setItem("work_game", gameCodee);
          props.setGameName("CHPT");
        } else {
          props.setGameName(gameCodee);
          localStorage.removeItem("work_game");
        }
        history.push("/lobby");
      }
    } else {
      props.setIsLoading(false);
      sessionStorage.setItem("gameCode", gameCodee);
      props.setGameName(gameCodee);
      history.push("/signup");
    }
  };

  return (
    <Row className="team-ch-row">
      <Col md={1} lg={1} className="p-0">
        <SideBarTabs
          current_user={current_user}
          handleOptClick={() => history.push("/outside_team_building")}
        />
      </Col>
      <Col md={11} lg={11} className="p-0">
        <main className="activities-main">
          <ActivityHeader
            history={history}
            activity_name={view_activity?.activity?.label}
            handleActivitiesClick={() => set_view_activity({})}
          />
          {_.isEmpty(view_activity) ? (
            <FindActivity
              onViewActivity={handleViewActivity}
              browse_activities={browse_activities}
            />
          ) : (
            <ViewActivity
              view_activity={view_activity}
              onStartActivity={handleStartActivity}
              onBackClick={() => set_view_activity({})}
            />
          )}
        </main>

        {!_.isEmpty(current_user?.team) && (
          <Footer
            link={link}
            teamCode={teamCode}
            sessionId={sessionId}
            sessionUsers={sessionObj?.users}
            team_session={team_session_params}
          />
        )}
      </Col>
    </Row>
  );
};

const mapDispatchToProps = (dispatch) => ({
  endGame: (data) => dispatch(gameAction.endGame(data)),
  setGameName: (data) => dispatch(gameAction.setGameName(data)),
  setEditions: (data) => dispatch(socketAction.setEditions(data)),
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  emptyGameData: (data) => dispatch(gameParamAction.emptyGameData(data)),
  setLTparameters: (data) => dispatch(socketAction.setLTparameters(data)),
  set_view_activity: (data) => dispatch(gameAction.set_view_activity(data)),
  setWellnessParamsOnject: (data) =>
    dispatch(gameAction.setWellnessParamsOnject(data))
});

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Activities);
